import { useContext, useEffect, useState } from 'react';
import { AdminContext } from '../context/AdminContext';
import { styles, StyledFloatingButton, StyledTable, ProductoContainer } from './components/productosComponents';
import Card from '../components/Card/Card';
import CardHeader from '../components/Card/CardHeader';
import CardBody from '../components/Card/CardBody.js';
import { makeStyles } from '@mui/styles';
import Fab from '@mui/material/Fab';
import Modalproducto from './components/ModalProducto';
import { UserContext } from '../context/UserContext';
import Filtros from './components/Filtros';
import { SNACKBAR_SEVERITY } from "../constants/index";
import { ProductContext } from '../context/ProductContext';
import CircleLoader from 'react-spinners/CircleLoader'
const useStyles = makeStyles(styles);

function Productos() {
  const { selectedUser, setSelectedUser, handleClickSnackbar } = useContext(AdminContext);
  const { productos, loading, updateFilterState, isLoadingProducts, setFilterState, filterState } = useContext(ProductContext);
  const { users, getUsers } = useContext(UserContext);

  // Styles
  const classes = useStyles();

  // States
  const [productSelection, setProductSelection] = useState(null);
  const [currentUser, setCurrentUser] = useState(selectedUser);
  const [modal, setModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [clearRowSelection, setClearRowSelection] = useState(false);
  const [userManuallySelected, setUserManuallySelected] = useState(!!selectedUser);
  const [savedFilterState, setSavedFilterState] = useState(null);

  function openModal() {
    if (!currentUser && !productSelection) {
      alert('Seleccione un usuario para comenzar a cargar el/los producto/s');
      return;
    }
    setModal(true);
  }

  function closeModal() {
    setProductSelection(null);
    setModal(false);
    // Only clear user if it was auto-selected from product, not manually selected
    if (!userManuallySelected) {
      setCurrentUser(null);
      // Restore previous filters and page if we had a snapshot
      if (savedFilterState) {
        setFilterState(savedFilterState);
        setSavedFilterState(null);
      }
    }
  }

  function modificarProducto(selectedItem) {
    setProductSelection(selectedItem);
  }

  function handleClearRows() {
    setClearRowSelection(!clearRowSelection);
    setSelectedRows([]);
  }

  useEffect(() => {
    if (selectedUser) {
      setFilterState(prev => ({ ...prev, UserId: selectedUser.identificador, page: 1, omitProductSelection: false }));
      setUserManuallySelected(true); // Mark as manually selected when coming from selectedUser
      setCurrentUser(selectedUser);
      setSelectedUser(null);
    } else if (currentUser && userManuallySelected) {
      // Only update filter state if user was manually selected
      setFilterState(prev => ({ ...prev, UserId: currentUser.identificador, page: 1, omitProductSelection: false }));
    }
  }, [selectedUser, currentUser, userManuallySelected]);

  useEffect(() => {
    getUsers();
    return () => {
      setCurrentUser(null);
      setSelectedUser(null);
      updateFilterState("UserId", null);
      setFilterState({
        userSearch: "",
        marca: "",
        estado: "CUALQUIERA",
        text: "",
        dateFrom: "",
        dateTo: "",
        codigo: "",
        display: 10,
        page: 1,
        omitProductSelection: false
      })
    }
  }, []);

  useEffect(() => {
    // Busca el usuario que corresponde al producto seleccionado
    if (productSelection) {
      const usr = users.find(usuario => usuario.identificador === productSelection.UserId)
      if (usr) {
        const wasManuallySelected = userManuallySelected;
        
        // If there was a manual selection, don't change the user or the manual flag
        if (wasManuallySelected) {
          // Keep the manually selected user, don't change currentUser
          // Don't change userManuallySelected flag
          // Don't snapshot filters since we're keeping the manual selection
        } else {
          // No manual selection, so this is a pure auto-selection
          setCurrentUser(usr);
          setUserManuallySelected(false); // Mark as auto-selected
          // Snapshot current filters to restore later (including page)
          setSavedFilterState(prev => prev ?? JSON.parse(JSON.stringify(filterState)));
        }
        
        openModal()
      } else {
        handleClickSnackbar('El dueño de este producto no fue encontrado en la base de datos', SNACKBAR_SEVERITY.info);
      }
    }
  }, [productSelection])


  return (
    <ProductoContainer>
      {modal ? <Modalproducto modal={modal} closeModal={closeModal} userSelection={currentUser} setCurrentUser={setCurrentUser} productSelection={productSelection} /> : null}

      <Card>
        <CardHeader color='warning'>
          <h2 className={classes.cardTitleWhite}>
            Productos
            {currentUser ? ` de: ${currentUser.nombreCompleto} (${currentUser.identificador})` : null}
          </h2>
          <h2 className={classes.cardTitleWhite}>
            {currentUser ? `Preferencia: ${currentUser.preferenciaPago}` : null}
          </h2>
          <p className={classes.cardCategoryWhite}>Listado de productos almacenados</p>
        </CardHeader>
        <CardBody>
          <Filtros classes={classes} currentUser={currentUser} setCurrentUser={setCurrentUser} setToggleCleared={handleClearRows} setUserManuallySelected={setUserManuallySelected} />
          <CircleLoader loading={loading} cssOverride={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
          <div style={{ opacity: loading ? 0 : 100 }}>
            {!isLoadingProducts && <StyledTable
              data={productos}
              omitCodigo={false}
              omitDate={false}
              setSelectedRows={setSelectedRows}
              selectedRows={selectedRows}
              modificarProducto={modificarProducto}
              toggleCleared={clearRowSelection}
              setToggleCleared={handleClearRows}
            />}
          </div>
        </CardBody>
      </Card>
      <StyledFloatingButton>
        <Fab color='secondary' aria-label='add' onClick={openModal}>
          +
        </Fab>
      </StyledFloatingButton>
    </ProductoContainer>
  );
}
export default Productos;
